// extracted by mini-css-extract-plugin
export default {"title":"UserDocumentVisible_title__IRTZn","checkbox":"UserDocumentVisible_checkbox__Z8mL1","checkboxTitle":"UserDocumentVisible_checkboxTitle__KZ4yL"};